/** @jsx React.DOM */

var React = require("react/addons");
var ModalActions = require("editor/actions/ModalActions");
var ModalStore = require("editor/stores/ModalStore");
var WatchStoreMixin = require("editor/mixins/WatchStore");

var Modal = React.createClass({displayName: 'Modal',
  mixins: [ WatchStoreMixin(ModalStore) ],

  getFluxState: function() {
    return ModalStore.getState();
  },

  handleCloseModal: function() {
    if (this.state.onClose) this.state.onClose(this);
    ModalActions.close();
  },

  handleApply: function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.onApply) this.state.onApply(this);
    ModalActions.close();
  },

  render: function() {
    if (!this.state.isVisible) return null;

    var modalStyle = {
      position: "absolute",
      "zIndex": "100"
      // top: this.props.y,
      // left: this.props.x
    };

    return (
      React.DOM.div({className: "modal-dialog", style: modalStyle}, 
        React.DOM.div({className: "modal-content"}, 
          React.DOM.form({onSubmit: this.handleApply}, 
            React.DOM.div({className: "modal-header"}, 
              React.DOM.button({type: "button", className: "close", 'data-dismiss': "modal", onClick: this.handleCloseModal}, 
                React.DOM.span({'aria-hidden': "true"}, "×"), React.DOM.span({className: "sr-only"}, "Cancel")
              ), 
              React.DOM.h4({className: "modal-title"}, this.state.title)
            ), 
            React.DOM.div({className: "modal-body"}, 
              this.state.content()
            ), 
            React.DOM.div({className: "modal-footer"}, 
              React.DOM.button({type: "button", className: "btn btn-default", 'data-dismiss': "modal", onClick: this.handleCloseModal}, "Cancel"), 
              React.DOM.input({type: "submit", onClick: this.handleApply, className: "btn btn-primary", value: "Apply"})
            )
          )
        )
      )
    );
  }
});

module.exports = Modal;





/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/common/Modal.js
 ** module id = 32
 ** module chunks = 0
 **/